import { fetchJson } from './client.js';

export const IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
export const MAX_IMAGE_SIZE = 10 * 1024 * 1024;

export function imageFileError(file) {
  if (!IMAGE_TYPES.includes(file.type)) return 'type';
  if (!file.size) return 'empty';
  if (file.size > MAX_IMAGE_SIZE) return 'size';
  return null;
}

export async function uploadLogo(file, { signal } = {}) {
  const body = new FormData();
  body.append('file', file);
  const { data } = await fetchJson('/upload/image?prefix=logos', {
    method: 'POST', auth: 'always', body, signal,
  });
  // Never replace the current logo with an unusable upload response.
  if (typeof data?.url !== 'string' || !/^https?:\/\//i.test(data.url)) {
    throw new Error('Invalid image upload response');
  }
  return data.url;
}
